import React, { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { showAlert } from '../../store/ducks/alert';

import DataTable from '../../components/Table/DataTable';
import SearchBox from '../../components/SearchBox/SearchBox';
import ImportData from './components/ImportData';
import { HighlightOff } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';

import { CircularProgress, Button, IconButton } from '@material-ui/core';

import { getLandingPages, sendPage, deleteLandingPage } from '../../services/landingPages';


const LandingPages = ({ location, match }) => { 
  const dispatch = useDispatch();
  const [landingPages, setLandingPages] = useState([]);
  const [page, setPage] = useState(0);
  const [isLoadingFile, setIsLoadingFile] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [isOrdering, setIsOrdering] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [importType, setImportType] = useState('substack');
  const [resetFile, setResetFile] = useState(false);
  const [remove, setRemove] = useState(false);
  const [data, setData] = useState({});
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });
  const [orderDirections, setOrderDirections] = useState({
    item: '',
    direction: '',
  });

  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);

  useEffect(() => {
    let currentPage = location.search.split('=')[1] || page;
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    displayChannels(currentPage);
  }, [isSearching, isOrdering, page]);

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const handleCloseRemoveAlert = () => {
    setRemove(false);
  };

  const handleFileUpload = async e => {
    try {
      setIsLoadingFile(true);
      const file = new FormData();
      file.append('file', e.target.files[0]);
      file.append('type', importType);
      setResetFile(true);
      await sendPage(file);
      setIsLoadingFile(false);
      dispatch(showAlert('success', 'imported!'));
    } catch (error) {
      dispatch(showAlert('error', 'something wrong happend'));
    } finally {
      setIsLoadingFile(false);
    }
  };

    const handleSubmitDelete = async () => {
      try {
        await deleteLandingPage(data.id);
        dispatch(showAlert('success', 'Landingpage deleted!'));
        window.location.reload();
      } catch (error) {
        dispatch(showAlert('error', 'Error! We could not deleted this Landing Page. 😔'));
      }
    };


  const displayChannels = async currentPage => {
    try {
      setIsLoading(true);

      let params = { order: orderDirections.item, direction: orderDirections.direction, limit: 5 };
      if (isSearching) params = { ...searchField, ...params };
      const { data: landingPages } = await getLandingPages(currentPage || page, params);

      setLandingPages(landingPages.rows);
      setTotalItems(landingPages.count);
      setTotalPages(landingPages.pages);
      setPage(landingPages.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };
   const customActions = [
     {
       icon: <HighlightOff />,
       action: item => {
         setData(item);
         setRemove(true);
       },
     },
   ];

  const headers = ['id', 'name', 'path', 's3Url', 'cloudFrontUrl', 'description', 'isActive', 'createdAt', 'updatedAt', 'deletedAt'];

  const SearchBoxHeaders = ['id', 'name', 'path', 's3Url', 'cloudFrontUrl', 'description'];

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>LandingPages ({totalItems})</h1>
        <SearchBox
          selectItems={SearchBoxHeaders}
          onSubmitSearch={handleSubmitSearch}
          isSearching={isSearching}
          setIsOrdering={setIsOrdering}
        />
      </div>

      <DataTable
        useUid={true}
        head={headers}
        body={landingPages}
        bodyColumn={headers}
        totalPages={totalPages}
        currentPage={page}
        orderDirections={orderDirections}
        setOrderDirections={setOrderDirections}
        setPageChange={setPage}
        setIsOrdering={setIsOrdering}
        isOrdering={isOrdering}
        customActions={customActions}
      />
      {remove ? (
        <div className="unsubscribe-container">
          <div className="unsubscribe-container-top">
            <h2>Are you sure you want to delete this Landing page?</h2>

            <IconButton onClick={handleCloseRemoveAlert}>
              <CloseIcon />
            </IconButton>
          </div>
          <div>
            <h4>{data.id}</h4>
          </div>
          <Button onClick={handleSubmitDelete} variant="contained" className="modal-btn">
            Yes
          </Button>
        </div>
      ) : (
        ''
      )}
      <div>
        <section>
          <ImportData
            isLoadingFile={isLoadingFile}
            onSubmit={e => {
              handleFileUpload(e);
            }}
            resetFile={resetFile}
            importType={importType}
            onChangeType={e => {
              setImportType(e);
            }}
          />
        </section>
      </div>
    </>
  );

};

export default LandingPages;